module.exports = __webpack_public_path__ + "img/calendario.0a18a95d.svg";